import * as React from 'react';

import { Tooltip } from '@emburse/ui-core';
import { Icon, InfoIcon } from '@emburse/ui-essentials';

const PARENT_CARD_TOOLTIP =
  'Parent card: Payment transactions may appear here. Map this card to track them, or leave it unmapped to hide them.';

export const ParentCardIndicator: React.FC = () => (
  <Tooltip title={PARENT_CARD_TOOLTIP}>
    <Icon iconUrl={InfoIcon} style={{ fontSize: '16px', cursor: 'help', marginLeft: '4px' }} />
  </Tooltip>
);
